import clsx from 'clsx'

interface CardNoteProps {
  className?: string
  children: preact.ComponentChildren
}

export function CardNote({ className, children }: CardNoteProps) {
  return (
    <div
      className={clsx(
        "aspect-square overflow-hidden absolute top-0 right-0  before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:origin-top-left before:scale-150 before:-rotate-45 before:z-0",
        className,
      )}>
      <div className="relative z10 flex justify-end items-start">{children}</div>
    </div>
  )
}
